import React from 'react';
import { ClockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="py-12 px-4 bg-red-50 border-y border-red-100" data-id="element-331">
      <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-332">
        <div className="flex items-center justify-center gap-3 mb-4" data-id="element-333">
          <ClockIcon className="w-8 h-8 text-red-600 animate-pulse" data-id="element-334" />
          <h2 className="text-2xl md:text-3xl font-bold text-red-600" data-id="element-335">
            ⏳ Questa offerta sparisce presto
          </h2>
        </div>
        <p className="text-gray-700 mb-6 text-lg" data-id="element-336">
          Non perdere l'opportunità di ottenere il pacchetto completo con l'81%
          di sconto.
        </p>
        <CountdownTimer variant="dark" className="scale-110" data-id="element-337" />
      </div>
    </section>;
}